import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Пенал выполнен из плотной ткани. Застёжка на молнии.</p>
        <p>Состав: 100% полиэстер</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
